module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9cf16e198b95ed7ff788cc318d836398.png";